import React from "react";

const Transiton = () => {
  return (
    <div>
    

    <div className="overflow-x-auto relative  max-h-96 overflow-y-scroll bg-white rounded-md ">
      <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
        <thead className="text-xs text-gray-500   uppercase bg-[#F3F2F7]">
          <tr>
            <th scope="col" className="py-3 px-6">
              ACTIVITY
            </th>
            <th scope="col" className="py-3 px-6">
              DATE
            </th>
            <th scope="col" className="py-3 px-6">
              AMOUNT
            </th>
            <th scope="col" className="py-3 px-6">
              Processes
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className="bg-white border-b ">
            <th
              scope="row"
              className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap "
            >
              Bank Asia
            </th>
            <td className="py-4 px-6">12/2/2022</td>
            <td className="py-4 px-6">23,585Tk</td>
            <td className="py-4 px-6 text-green-600 ">successful</td>
          </tr>
          <tr className="bg-white border-b ">
            <th
              scope="row"
              className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap "
            >
              Visa card
            </th>
            <td className="py-4 px-6">12/2/2022</td>
            <td className="py-4 px-6">23,585Tk</td>
            <td className="py-4 px-6 text-red-600">Reject</td>
          </tr>
          <tr className="bg-white border-b ">
            <th
              scope="row"
              className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap "
            >
              Bank Asia
            </th>
            <td className="py-4 px-6">12/2/2022</td>
            <td className="py-4 px-6">23,585Tk</td>
            <td className="py-4 px-6 text-green-600 ">successful</td>
          </tr>
        
          <tr className="bg-white border-b ">
            <th
              scope="row"
              className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap "
            >
              Bank Asia
            </th>
            <td className="py-4 px-6">12/2/2022</td>
            <td className="py-4 px-6">23,585Tk</td>
            <td className="py-4 px-6 text-green-600 ">successful</td>
          </tr>
          <tr className="bg-white border-b ">
            <th
              scope="row"
              className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap "
            >
              Bank Asia
            </th>
            <td className="py-4 px-6">12/2/2022</td>
            <td className="py-4 px-6">23,585Tk</td>
            <td className="py-4 px-6 text-green-600 ">successful</td>
          </tr>
          <tr className="bg-white border-b ">
            <th
              scope="row"
              className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap "
            >
              Bank Asia
            </th>
            <td className="py-4 px-6">12/2/2022</td>
            <td className="py-4 px-6">23,585Tk</td>
            <td className="py-4 px-6 text-green-600 ">successful</td>
          </tr>
        </tbody>
      </table>
    </div>
    </div>
  );
};

export default Transiton;
